import { render, staticRenderFns } from "./GallerySearch.vue?vue&type=template&id=5523acba&scoped=true&"
import script from "./GallerySearch.vue?vue&type=script&lang=js&"
export * from "./GallerySearch.vue?vue&type=script&lang=js&"
import style0 from "./GallerySearch.vue?vue&type=style&index=0&id=5523acba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523acba",
  null
  
)

export default component.exports